/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from "@react-three/drei";

// @ts-ignore
export function Model(props) {
  // @ts-ignore
  const { nodes, materials } = useGLTF("/desk-kinda--two.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.desktop.geometry}
        material={materials["rough-black"]}
        position={[0, 0.67, 0]}
        rotation={[-Math.PI, 0, 0]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.leg1.geometry}
        material={nodes.leg1.material}
        position={[0.61, 0.64, 0]}
        rotation={[-Math.PI, 0, 0]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.leg2.geometry}
        material={materials["metallic-white"]}
        position={[0.61, 0.64, 0]}
        rotation={[-Math.PI, 0, 0]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube.geometry}
        material={materials["rough-black"]}
        position={[0.49, 0.68, -0.01]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube001.geometry}
        material={materials["rough-black"]}
        position={[-0.03, 0.69, 0.04]}
        scale={[0.22, 0.01, 0.07]}
      />
      <group position={[-0.03, 1.03, -0.2]} rotation={[0, Math.PI / 2, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube006.geometry}
          material={materials["rough-black"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube006_1.geometry}
          material={materials.screen}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/desk-kinda.glb");
